// extracted by mini-css-extract-plugin
export default {"cls1":"LanguageSwitcherModal-cls1___1235a956fec2eeafbe6","cls2":"LanguageSwitcherModal-cls2___bc0a9500033edc6883a LanguageSwitcherModal-cls1___1235a956fec2eeafbe6"};